/* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable no-nested-ternary */ /* eslint-disable camelcase */ /* eslint-disable no-unused-vars */ /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ /* eslint-disable react/prop-types */ import React from 'react';
import { useTranslation } from 'react-i18next';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import { CostCenterTableRow } from './CostCenterTableRow';

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
  },
  table: {
    minWidth: 1100,
  },
});

const StyledTableCell = withStyles(() => ({
  head: {
    backgroundColor: '#303474',
    color: 'white',
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

// eslint-disable-next-line import/prefer-default-export
export function CostCentersTable({
  docs,
  page,
  setPage,
  itens,
  setItens,
  total,
  searchData,
}) {
  const { t } = useTranslation();
  const classes = useStyles();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setItens(event.target.value);
  };

  return (
    <Paper className={classes.root}>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>{t('costCenters.table.name')}</StyledTableCell>
              <StyledTableCell>{t('costCenters.table.code')}</StyledTableCell>
              <StyledTableCell>
                {t('costCenters.table.creation')}
              </StyledTableCell>
              {/* <StyledTableCell /> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {docs.map(row => {
              return (
                <CostCenterTableRow
                  key={row.id}
                  docs={row}
                  searchData={searchData}
                />
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 50, 100, 1000, 50000]}
        component="div"
        count={total}
        rowsPerPage={itens}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </Paper>
  );
}
